import React, { useState } from 'react';
import { ShoppingBag, User, Heart, Search, Menu, X, ArrowRight, ChevronRight, Plus, Instagram, Play } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Template17 = () => {
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [hoveredProduct, setHoveredProduct] = useState(null);

    const collections = [
        { name: 'New Season', image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800&h=1000&fit=crop' },
        { name: 'Best Sellers', image: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=800&h=1000&fit=crop' },
    ];

    const lookbook = [
        { image: 'https://images.unsplash.com/photo-1509631179647-0177331693ae?w=600&h=750&fit=crop', title: 'The Edit' },
        { image: 'https://images.unsplash.com/photo-1485968579580-b6d095142e6e?w=600&h=750&fit=crop', title: 'Essentials' },
        { image: 'https://images.unsplash.com/photo-1495385794356-15371f348c31?w=600&h=750&fit=crop', title: 'Evening' },
        { image: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=600&h=750&fit=crop', title: 'Casual' },
    ];

    const products = [
        { name: 'Draped Silk Blouse', price: 3200, color: 'Ivory', image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=500&h=700&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=500&h=700&fit=crop', tag: 'New' },
        { name: 'Tailored Linen Trousers', price: 4500, color: 'Sand', image: 'https://images.unsplash.com/photo-1509631179647-0177331693ae?w=500&h=700&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1485968579580-b6d095142e6e?w=500&h=700&fit=crop', tag: null },
        { name: 'Floral Midi Dress', price: 5800, color: 'Blush', image: 'https://images.unsplash.com/photo-1495385794356-15371f348c31?w=500&h=700&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=500&h=700&fit=crop', tag: 'Bestseller' },
        { name: 'Cotton Kurta Set', price: 3800, color: 'Sage', image: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=500&h=700&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&h=700&fit=crop', tag: null },
        { name: 'Relaxed Blazer', price: 6200, color: 'Charcoal', image: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=500&h=700&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1506629082955-511b1aa562c8?w=500&h=700&fit=crop', tag: 'New' },
        { name: 'Pleated Midi Skirt', price: 2900, color: 'Navy', image: 'https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=500&h=700&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=500&h=700&fit=crop', tag: null },
        { name: 'Oversized Shirt Dress', price: 4200, color: 'White', image: 'https://images.unsplash.com/photo-1594040226829-7f251ab46d80?w=500&h=700&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=500&h=700&fit=crop', tag: null },
        { name: 'Embroidered Top', price: 2600, color: 'Cream', image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&h=700&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=500&h=700&fit=crop', tag: 'Limited' },
    ];

    const instagramPosts = [
        'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=400&h=400&fit=crop',
        'https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=400&h=400&fit=crop',
        'https://images.unsplash.com/photo-1509631179647-0177331693ae?w=400&h=400&fit=crop',
        'https://images.unsplash.com/photo-1485968579580-b6d095142e6e?w=400&h=400&fit=crop',
        'https://images.unsplash.com/photo-1495385794356-15371f348c31?w=400&h=400&fit=crop',
        'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=400&h=400&fit=crop',
    ];

    return (
        <div className="w-full min-h-screen bg-white font-sans">
            {/* Top Bar */}
            <div className="bg-neutral-900 text-white text-center py-2 text-xs tracking-widest">
                FREE SHIPPING ON ORDERS OVER ₹2,000 | EASY RETURNS
            </div>

            {/* Header */}
            <header className="bg-white sticky top-0 z-50 border-b border-neutral-100">
                <div className="max-w-screen-2xl mx-auto">
                    <div className="flex items-center justify-between px-6 lg:px-12 py-4">
                        {/* Mobile Menu */}
                        <button className="lg:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                            {mobileMenuOpen ? <X className="w-5 h-5 text-neutral-800" /> : <Menu className="w-5 h-5 text-neutral-800" />}
                        </button>

                        {/* Desktop Nav Left */}
                        <nav className="hidden lg:flex items-center gap-8">
                            <button onClick={() => navigate('/template17/shop')} className="text-sm text-neutral-700 hover:text-neutral-900 transition-colors tracking-wide">
                                Shop
                            </button>
                            <button className="text-sm text-neutral-700 hover:text-neutral-900 transition-colors tracking-wide">
                                Collections
                            </button>
                            <button className="text-sm text-neutral-700 hover:text-neutral-900 transition-colors tracking-wide">
                                Lookbook
                            </button>
                        </nav>

                        {/* Logo */}
                        <h1 onClick={() => navigate('/template17')} className="text-2xl lg:text-3xl font-semibold tracking-[0.15em] text-neutral-900 cursor-pointer">
                            BLUM
                        </h1>

                        {/* Icons Right */}
                        <div className="flex items-center gap-5">
                            <Search className="w-5 h-5 text-neutral-700 cursor-pointer hover:text-neutral-900 transition-colors" />
                            <User className="w-5 h-5 text-neutral-700 cursor-pointer hover:text-neutral-900 transition-colors hidden sm:block" onClick={() => navigate('/template17/profile')} />
                            <Heart className="w-5 h-5 text-neutral-700 cursor-pointer hover:text-neutral-900 transition-colors hidden sm:block" />
                            <div className="relative cursor-pointer" onClick={() => navigate('/template17/cart')}>
                                <ShoppingBag className="w-5 h-5 text-neutral-700 hover:text-neutral-900 transition-colors" />
                                <span className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-neutral-900 text-white text-[10px] rounded-full flex items-center justify-center">0</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mobile Menu */}
                {mobileMenuOpen && (
                    <div className="lg:hidden bg-white border-t border-neutral-100">
                        <nav className="px-6 py-8 space-y-5">
                            <button onClick={() => { navigate('/template17/shop'); setMobileMenuOpen(false); }} className="block text-base text-neutral-800">Shop</button>
                            <button className="block text-base text-neutral-800">Collections</button>
                            <button className="block text-base text-neutral-800">Lookbook</button>
                            <button onClick={() => { navigate('/template17/contact'); setMobileMenuOpen(false); }} className="block text-base text-neutral-800">Contact</button>
                        </nav>
                    </div>
                )}
            </header>

            {/* Hero - Split Screen */}
            <section className="grid grid-cols-1 lg:grid-cols-2 min-h-[90vh]">
                {collections.map((collection, idx) => (
                    <div key={idx} className="relative group cursor-pointer overflow-hidden">
                        <img
                            src={collection.image}
                            alt={collection.name}
                            className="w-full h-full min-h-[50vh] lg:min-h-[90vh] object-cover group-hover:scale-105 transition-transform duration-700"
                        />
                        <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-500"></div>
                        <div className="absolute inset-0 flex items-end p-8 lg:p-12">
                            <div>
                                <h2 className="text-3xl lg:text-4xl font-light text-white mb-4">{collection.name}</h2>
                                <button className="group/btn flex items-center gap-2 text-white text-sm tracking-wider border-b border-white pb-1 hover:gap-3 transition-all">
                                    Shop Now <ArrowRight className="w-4 h-4" />
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </section>

            {/* Featured Products */}
            <section className="py-20 lg:py-28">
                <div className="max-w-screen-2xl mx-auto px-6 lg:px-12">
                    <div className="flex items-end justify-between mb-12">
                        <div>
                            <p className="text-neutral-500 text-sm tracking-wider mb-2">CURATED FOR YOU</p>
                            <h2 className="text-3xl lg:text-4xl font-light text-neutral-900">New Arrivals</h2>
                        </div>
                        <button onClick={() => navigate('/template17/shop')} className="hidden md:flex items-center gap-2 text-sm text-neutral-700 hover:text-neutral-900 transition-colors">
                            View All <ChevronRight className="w-4 h-4" />
                        </button>
                    </div>

                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
                        {products.map((product, idx) => (
                            <div
                                key={idx}
                                className="group"
                                onMouseEnter={() => setHoveredProduct(idx)}
                                onMouseLeave={() => setHoveredProduct(null)}
                            >
                                <div className="relative aspect-[3/4] overflow-hidden mb-4 bg-neutral-100">
                                    <img
                                        src={hoveredProduct === idx ? product.hoverImage : product.image}
                                        alt={product.name}
                                        className="w-full h-full object-cover transition-all duration-500"
                                    />
                                    {product.tag && (
                                        <span className="absolute top-3 left-3 bg-neutral-900 text-white text-xs px-3 py-1">{product.tag}</span>
                                    )}
                                    <button className="absolute top-3 right-3 w-9 h-9 bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 shadow-sm">
                                        <Heart className="w-4 h-4 text-neutral-700" />
                                    </button>
                                    <button className="absolute bottom-4 left-4 right-4 py-3 bg-white text-neutral-900 text-xs tracking-widest opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 flex items-center justify-center gap-2">
                                        <Plus className="w-3 h-3" /> ADD TO BAG
                                    </button>
                                </div>
                                <div>
                                    <p className="text-xs text-neutral-500 mb-1">{product.color}</p>
                                    <h3 className="text-sm text-neutral-900 mb-1">{product.name}</h3>
                                    <p className="text-sm text-neutral-700">₹{product.price.toLocaleString()}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-10 md:hidden">
                        <button onClick={() => navigate('/template17/shop')} className="text-sm text-neutral-800 border-b border-neutral-400 pb-1">
                            View All Products
                        </button>
                    </div>
                </div>
            </section>

            {/* Lookbook Section */}
            <section className="py-20 lg:py-28 bg-neutral-50">
                <div className="max-w-screen-2xl mx-auto px-6 lg:px-12">
                    <div className="text-center mb-14">
                        <p className="text-neutral-500 text-sm tracking-wider mb-2">SEASONAL EDIT</p>
                        <h2 className="text-3xl lg:text-4xl font-light text-neutral-900">The Lookbook</h2>
                    </div>

                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                        {lookbook.map((item, idx) => (
                            <div key={idx} className="group cursor-pointer">
                                <div className="relative aspect-[4/5] overflow-hidden">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                    />
                                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-500"></div>
                                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                                        <span className="text-white text-lg tracking-wider">{item.title}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-10">
                        <button className="text-sm text-neutral-800 tracking-wider border-b border-neutral-800 pb-1 hover:text-neutral-600 hover:border-neutral-600 transition-colors">
                            VIEW FULL LOOKBOOK
                        </button>
                    </div>
                </div>
            </section>

            {/* Video Banner */}
            <section className="relative h-[70vh]">
                <img
                    src="https://images.unsplash.com/photo-1509631179647-0177331693ae?w=1600&h=900&fit=crop"
                    alt="Video Banner"
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/40"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-center">
                        <button className="w-20 h-20 bg-white rounded-full flex items-center justify-center mb-6 mx-auto hover:scale-110 transition-transform">
                            <Play className="w-8 h-8 text-neutral-800 ml-1" />
                        </button>
                        <p className="text-white/80 text-xs tracking-[0.3em] mb-3">WATCH THE FILM</p>
                        <h2 className="text-4xl lg:text-5xl font-light text-white">Behind The Collection</h2>
                    </div>
                </div>
            </section>

            {/* Story Section */}
            <section className="py-20 lg:py-28">
                <div className="max-w-screen-2xl mx-auto px-6 lg:px-12">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                        <div className="order-2 lg:order-1">
                            <p className="text-neutral-500 text-sm tracking-wider mb-4">OUR PHILOSOPHY</p>
                            <h2 className="text-3xl lg:text-4xl font-light text-neutral-900 mb-6 leading-relaxed">
                                Thoughtfully Designed, Consciously Made
                            </h2>
                            <p className="text-neutral-600 leading-relaxed mb-6">
                                At Blum, we believe in creating clothing that transcends trends. Each piece is designed
                                with intention, crafted from quality materials, and made to become a lasting part of your wardrobe.
                            </p>
                            <p className="text-neutral-600 leading-relaxed mb-8">
                                We work with skilled artisans across India, combining traditional techniques with modern design
                                to create pieces that feel both timeless and contemporary.
                            </p>
                            <button className="text-sm text-neutral-900 tracking-wider border-b border-neutral-900 pb-1 hover:text-neutral-600 hover:border-neutral-600 transition-colors">
                                LEARN MORE
                            </button>
                        </div>
                        <div className="order-1 lg:order-2">
                            <img
                                src="https://images.unsplash.com/photo-1485968579580-b6d095142e6e?w=800&h=1000&fit=crop"
                                alt="Our Story"
                                className="w-full aspect-[4/5] object-cover"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Instagram Feed */}
            <section className="py-16 lg:py-20 bg-neutral-50">
                <div className="max-w-screen-2xl mx-auto px-6 lg:px-12">
                    <div className="text-center mb-10">
                        <div className="flex items-center justify-center gap-2 mb-4">
                            <Instagram className="w-5 h-5 text-neutral-700" />
                            <span className="text-sm text-neutral-700 tracking-wider">@blum.india</span>
                        </div>
                        <h2 className="text-2xl lg:text-3xl font-light text-neutral-900">Follow Our Journey</h2>
                    </div>

                    <div className="grid grid-cols-3 lg:grid-cols-6 gap-2">
                        {instagramPosts.map((post, idx) => (
                            <div key={idx} className="aspect-square group cursor-pointer overflow-hidden">
                                <img
                                    src={post}
                                    alt={`Instagram ${idx + 1}`}
                                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Newsletter */}
            <section className="py-20 lg:py-24 bg-neutral-900 text-white">
                <div className="max-w-xl mx-auto px-6 text-center">
                    <h2 className="text-2xl lg:text-3xl font-light mb-4">Join the List</h2>
                    <p className="text-neutral-400 text-sm mb-8">
                        Subscribe for exclusive access to new collections, special offers, and style inspiration.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3">
                        <input
                            type="email"
                            placeholder="Your email address"
                            className="flex-1 px-5 py-4 bg-neutral-800 border-0 text-white text-sm placeholder-neutral-500 focus:outline-none focus:ring-1 focus:ring-neutral-600"
                        />
                        <button className="px-8 py-4 bg-white text-neutral-900 text-xs tracking-widest hover:bg-neutral-200 transition-colors">
                            SUBSCRIBE
                        </button>
                    </div>
                    <p className="text-neutral-500 text-xs mt-4">No spam. Unsubscribe anytime.</p>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-white border-t border-neutral-200">
                <div className="max-w-screen-2xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-10 lg:gap-16">
                        <div className="md:col-span-1">
                            <h3 className="text-xl font-semibold tracking-[0.1em] mb-6">BLUM</h3>
                            <p className="text-neutral-600 text-sm leading-relaxed">
                                Modern essentials for the contemporary wardrobe. Thoughtfully made in India.
                            </p>
                        </div>

                        <div>
                            <h4 className="text-xs tracking-widest mb-5 text-neutral-500">SHOP</h4>
                            <ul className="space-y-3 text-sm">
                                <li><span onClick={() => navigate('/template17/shop')} className="text-neutral-700 hover:text-neutral-900 cursor-pointer transition-colors">All Products</span></li>
                                <li><span className="text-neutral-700 hover:text-neutral-900 cursor-pointer transition-colors">New Arrivals</span></li>
                                <li><span className="text-neutral-700 hover:text-neutral-900 cursor-pointer transition-colors">Bestsellers</span></li>
                                <li><span className="text-neutral-700 hover:text-neutral-900 cursor-pointer transition-colors">Sale</span></li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="text-xs tracking-widest mb-5 text-neutral-500">HELP</h4>
                            <ul className="space-y-3 text-sm">
                                <li><span onClick={() => navigate('/template17/contact')} className="text-neutral-700 hover:text-neutral-900 cursor-pointer transition-colors">Contact Us</span></li>
                                <li><span onClick={() => navigate('/template17/orders')} className="text-neutral-700 hover:text-neutral-900 cursor-pointer transition-colors">Track Order</span></li>
                                <li><span className="text-neutral-700 hover:text-neutral-900 cursor-pointer transition-colors">Shipping</span></li>
                                <li><span className="text-neutral-700 hover:text-neutral-900 cursor-pointer transition-colors">Size Guide</span></li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="text-xs tracking-widest mb-5 text-neutral-500">CONNECT</h4>
                            <ul className="space-y-3 text-sm">
                                <li className="text-neutral-700">hello@blum.in</li>
                                <li className="text-neutral-700">+91 98765 43210</li>
                                <li className="text-neutral-700 pt-2">Mon - Sat: 10am - 7pm</li>
                            </ul>
                        </div>
                    </div>

                    <div className="border-t border-neutral-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-neutral-500 text-xs">© 2025 Blum. All rights reserved.</p>
                        <div className="flex gap-6 text-xs text-neutral-500">
                            <span className="hover:text-neutral-900 cursor-pointer transition-colors">Privacy Policy</span>
                            <span className="hover:text-neutral-900 cursor-pointer transition-colors">Terms of Service</span>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Template17;
